// extracted by mini-css-extract-plugin
module.exports = {"main":"index-module--main--RfzjA","gide":"index-module--gide--3rAdq","bgPattern":"index-module--bgPattern--19-3H","bgNone":"index-module--bgNone--1g3Pt"};